import { computed } from 'vue'

import SchemaLeaf from '../SchemaLeaf/SchemaLeaf.vue'
import SchemaMarkupButton from '../SchemaMarkupButton/SchemaMarkupButton.vue'

const MAX_DEPTH = 2

function nodeText(node) {
    if (node.key === "@type") {
        return ""
    }
    if (node.control === "list") {
        return `${node.label || "elementer"} (${node.items.length})`
    }
    if (node.control === "fieldset") {
        return node.label || (node.meta && node.meta.type) || "…"
    }
    return node.value == null ? "" : String(node.value)
}

function summarize(field) {
    const nodes = field.control === "list" ? field.items : field.fields
    return nodes.map(nodeText).filter(Boolean).join("; ")
}

function blankDescriptor(template) {
    if (!template) {
        return { control: "text", key: null, label: "", value: "", readonly: false, path: "" }
    }

    const clone = JSON.parse(JSON.stringify(template))
    const reset = (node) => {
        if (node.control === "fieldset") {
            node.fields.forEach(reset)
        } else if (node.control === "list") {
            node.items = []
        } else if (node.key !== "@type") {
            node.value = node.control === "checkbox" ? false : ""
        }
    }
    reset(clone)
    return clone
}

export default {
    name: "SchemaField",

    components: {
        SchemaLeaf,
        SchemaMarkupButton
    },

    props: {
        field: {
            type: Object,
            required: true
        },
        depth: {
            type: Number,
            default: 1
        }
    },

    setup(props) {
        const expanded = computed(() => props.depth < MAX_DEPTH || Boolean(props.field.kind))
        const summary = computed(() => summarize(props.field))

        const addItem = (list) => {
            const template = list.items[list.items.length - 1] || (list.meta && list.meta.itemTemplate)
            list.items.push(blankDescriptor(template))
        }

        const removeItem = (list, index) => {
            list.items.splice(index, 1)
        }

        return { expanded, summary, addItem, removeItem }
    }
}
